window.addEventListener('hs-form-event:on-submission:success', function (
	event: CustomEvent<{ formId: string; instanceId: string }>
) {
	if (window.dataLayer) {
		window.dataLayer.push({
			event: 'hubspot-form-success',
			'hs-form-guid': event.detail.formId,
			'hs-form-instance-id': event.detail.instanceId,
		});
	}
} as EventListener);
